


















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import UserQuestionFormView from './UserQuestionFormView.vue'
import { checkMobile } from '../../utils/utils'

@Component({
  components: {
    Simplemde,
    UserQuestionFormView,
  }
})
export default class UserQuestionDialog extends Vue {
  @Prop({ default: '' }) courseId: string
  @Prop({ default: '' }) lessonId: string
  dialog: boolean = false
  mobile = checkMobile()
}
